import { render, staticRenderFns } from "./upgrade.vue?vue&type=template&id=775073c8&scoped=true"
var script = {}
import style0 from "./upgrade.vue?vue&type=style&index=0&id=775073c8&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "775073c8",
  null
  
)

export default component.exports